/**
 * 从 Touch 事件中获取两个触控中心位置
 */
export default function getMultipleTouchPosition(evt) {
    var _a = evt.touches[0], clientX = _a.clientX, clientY = _a.clientY;
    if (evt.touches.length >= 2) {
        var _b = evt.touches[1], nextClientX = _b.clientX, nextClientY = _b.clientY;
        return [(clientX + nextClientX) / 2, (clientY + nextClientY) / 2, Math.sqrt(Math.pow((nextClientX - clientX), 2) + Math.pow((nextClientY - clientY), 2))];
    }
    return [clientX, clientY, 0];
}
